import './ChatIframe.css';

interface ChatIframeProps {
  chatUrl: string;
  title?: string;
  className?: string;
}

const ChatIframe: React.FC<ChatIframeProps> = ({ 
  chatUrl, 
  title = "AI Chat",
  className = ""
}) => {
  return (
    <div className={`chat-iframe-container ${className}`}>
      <div className="chat-iframe-header">
        <h3 className="chat-iframe-title">{title}</h3>
      </div>
      <div className="chat-iframe-content">
        <iframe
          src={chatUrl}
          style={{
            width: '100%',
            height: '100%',
            minHeight: '700px',
            border: 'none'
          }}
          frameBorder="0"
          scrolling="auto"
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-pointer-lock allow-top-navigation"
          allow="microphone; camera; geolocation; autoplay"
          allowFullScreen
          title={title}
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default ChatIframe;